// Import the comprehensive AdminDashboard
import AdminDashboard from './AdminDashboard';

// Use AdminDashboard as the main employee dashboard
const EmployeeDashboard = () => {
    return <AdminDashboard />;
};

export default EmployeeDashboard; 